<template>
  <div class="storeAddCard">
    <div class="storeAddCardTitle">
      <el-page-header @back="goBack" content=""> </el-page-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'moneyManage' }"
          ><span class="titleText">财务管理</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ name: 'storeWithdrawal' }"
          ><span class="titleText">店铺余额提现</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ name: 'storeAddWidthDrawalCard' }"
          ><span class="titleText">个人店铺添加提现卡</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>

    <div v-loading="loading" class="mainBox">
      <div class="mainBoxForm">
        <el-form
          ref="form"
          size="mini"
          :model="storeAddCardForm"
          label-width="120px"
        >
          
          <el-form-item label="持卡人姓名：">
            <el-input
              class="inputMoney selectedBankItem"
              placeholder="如：张三"
              v-model="storeAddCardForm.bank_account_name"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="银行卡号：">
            <el-input
              class="inputMoney selectedBankItem"
              placeholder="银行卡号15-19位数字"
              @blur="checkCardType"
              v-model="storeAddCardForm.bank_account"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="银行卡类型：">
            <el-select
              class="selectedBankItem"
              v-model="storeAddCardForm.gate_id"
              filterable
              placeholder="请选择或搜索银行卡类型"
            >
              <el-option
                v-for="(item, index) in bankList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行预留手机号：">
            <el-input
              class="inputMoney selectedBankItem"
              placeholder="用于接收提现等操作的通知短信"
              v-model="storeAddCardForm.mobile_id"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="() => onSubmit()" type="info"
              >确认并绑定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  addRecharge,
  getStoreAccountUrl,
  listBankCardUrl,
  bindCompanyCardUrl,
  alipayCardbinValidateUrl,
  addWtdCard
} from "@/api/api";
import bankList from "@/utils/bank";
export default {
  name: "storeAddCard",
  data() {
    return {
      type: "企业账户",
      loading: false,
      storeAddCardForm: {
        bank_account: "",
        bank_account_name: "",
        account_pro: 2,
        gate_id: "",
        mobile_id: "",
      },
      cardList: [],
    };
  },
  computed: {
    ...mapState(["userInfo", "companyInfo"]),
  },
  created() {
    this.bankList = bankList;
  },
  methods: {
    searchCardName() {
      window.open("https://www.hebbank.com/corporbank/otherBankQueryWeb.do");
    },
    addWithdrawalCard() {
      if (this.companyInfo && this.companyInfo.type != 9) {
        this.$router.push("addStoreWithDrawalCard");
      } else {
        this.$alert("该绑个人提现卡了啊");
      }
    },
    getBankInfo(gate_id) {
      let current = this.bankList.filter((item) => {
        return item.value == gate_id;
      })[0];
      return current;
    },

    goBack() {
      this.$router.go(-1);
    },
    checkCardType() {
      let { bank_account } = this.storeAddCardForm;
      let data = {
        _input_charset: "utf-8",
        cardNo: bank_account,
        cardBinCheck: true,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({
        method: "post",
        data: param,
        url: alipayCardbinValidateUrl,
      })
        .then((res) => {
            if (res.data.validated) {
              console.log(res.data.bank)
              this.storeAddCardForm = {
                ...this.storeAddCardForm,
                gate_id:res.data.bank
              }
            }else{
                this.storeAddCardForm = {
                ...this.storeAddCardForm,
                gate_id:"QTYH"
              }
            }
        })
        .catch((error) => {});
    },
    bindWidthDrawalCard() {
      this.loading = true;
      let {
        bank_account,
        bank_account_name,
        gate_id,
        mobile_id,
      } = this.storeAddCardForm;
      let data = {
        access_token: this.userInfo.access_token,
        bank_account:(bank_account+"").trim(),
        bank_account_name:(bank_account_name+"").trim(),
        gate_id,
        mobile_id:(mobile_id+"").trim(),
        store_id:this.companyInfo.storeId
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: addWtdCard })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.$alert("绑定成功!", "成功").then(() => {
              this.$router.go(-1);
            });
          } else {
            this.loading = false;
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    onSubmit() {
      if (this.checkValue()) {
        this.bindWidthDrawalCard();
      }
    },
    checkValue() {
      let {
        bank_account,
        bank_account_name,
        gate_id,
        mobile_id,
      } = this.storeAddCardForm;
      console.log(this.storeAddCardForm);
      if (!bank_account.trim()) {
        this.$alert("请输入银行卡号");
        return false;
      }
      if (!bank_account_name.trim()) {
        this.$alert("请输入持卡人姓名");
        return false;
      }
      if (!gate_id.trim()) {
        this.$alert("请选择开户银行类型");
        return false;
      }
      if (!mobile_id.trim()) {
        this.$alert("请输入银行预留手机号");
        return false;
      }
      if (!/([0-9]{11})/.test(mobile_id.trim())) {
        this.$alert("手机号格式有误");
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped lang='less'>
.storeAddCard {
  padding: 10px;
}
.titleText {
  font-size: 13px;
  color: #009e96 !important;
}
.storeAddCardTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.formInfo {
  width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 13px;
  color: #009688;
  border-radius: 2px;
  margin-bottom: 10px;
  height: 20px;
}
.mainBoxForm {
}
.inputMoney {
  width: 200px;
}
.mainBox {
  margin-top: 30px;
  padding-bottom: 30px;
}
.s_name {
  font-size: 13px;
}
.selectedBankItem {
  width: 250px;
}
.linkA {
  // margin-top: -10px;
  // margin-bottom: 15px;
  position: relative;
  top: -10px;
  margin-left: 122px;
  font-size: 12px;
  text-decoration: underline;
  color: #3a8ee6;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/ChildStoreWidthDrawalCard.vue